<div class="report-content">
    <div style="display: flex; justify-content: space-between;">
        <h2>{{'monitoring.graphs.neverLogged.fullLabel' | translate}}</h2>
    </div>
    <ng-container>
        <div *ngIf="users.length==0">{{'monitoring.graphs.noData.fullLabel' | translate}}</div>
        <div *ngIf="users.length>0" class="table-container">
            <aside class="locked">
                <table>
                    <thead>
                        <tr>
                            <th>{{'monitoring.graphs.user.shortLabel'         | translate}}</th>
                            <th>{{'monitoring.graphs.email.shortLabel'        | translate}}</th>
                            <th>{{'monitoring.filters.region.shortLabel'      | translate}}</th>
                            <th>{{'monitoring.filters.licenceType.shortLabel' | translate}}</th>
                            <th>{{'monitoring.graphs.licence.shortLabel'      | translate}}</th>
                            <th>{{'monitoring.filters.banker.shortLabel'      | translate}}</th>
                            <th>{{'monitoring.graphs.creationDate.shortLabel' | translate}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let user of users" class="deep-0">
                            <td>{{user.userName    }}</td>
                            <td>{{user.userEmail   }}</td>
                            <td>{{user.regionLabel }}</td>
                            <td>{{user.licenceType }}</td>
                            <td>{{user.licenceLabel}}</td>
                            <td>{{user.bankerName  }}</td>
                            <td>{{user.creationDate}}</td>
                        </tr>
                    </tbody>
                </table>
            </aside>
        </div>
    </ng-container>
</div>
